import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Group, DataApiResponseLegacy } from '@digilize/shared/definitions/src';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GroupsApiService {
  constructor(private http: HttpClient) {}
  readonly BASE_URL = '/api/v1.0/groups';

  getGroupProducts(permalink: string): Observable<any> {
    return this.http.get(`${this.BASE_URL}/${permalink}/products`);
  }

  getGroups = () => this.http.get<Group[]>(`${this.BASE_URL}`);
  searchGroups = (term: string) =>
    this.http.get<{ term: string; result: DataApiResponseLegacy<Group[]> }>(`${this.BASE_URL}/search?term=${term}`);
}
